module.exports = __webpack_public_path__ + "img/icon_sm_cylysq.df56d52d.png";